import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ClientViewState {
  active: boolean;
  userId: number | null;
  displayName: string;
  isChatBotAllowed: boolean;
  isIntegrationUser: boolean;
  isCalibrateAdmin: boolean;
}

export interface SetClientViewPayload {
  userId: number;
  displayName: string;
  isChatBotAllowed: boolean;
  isIntegrationUser: boolean;
  isCalibrateAdmin: boolean;
}

const initialState: ClientViewState = {
  active: false,
  userId: null,
  displayName: "",
  isChatBotAllowed: false,
  isIntegrationUser: false,
  isCalibrateAdmin: false,
};

const clientViewSlice = createSlice({
  name: "clientView",
  initialState,
  reducers: {
    setClientView: (state, action: PayloadAction<SetClientViewPayload>) => {
      const { userId, displayName, isChatBotAllowed, isIntegrationUser, isCalibrateAdmin } =
        action.payload;
      state.active = true;
      state.userId = userId;
      state.displayName = displayName;
      state.isChatBotAllowed = isChatBotAllowed;
      state.isIntegrationUser = isIntegrationUser;
      state.isCalibrateAdmin = isCalibrateAdmin;
    },
    clearClientView: (state) => {
      state.active = false;
      state.userId = null;
      state.displayName = "";
      state.isChatBotAllowed = false;
      state.isIntegrationUser = false;
      state.isCalibrateAdmin = false;
    },
  },
});

export const { setClientView, clearClientView } = clientViewSlice.actions;
export default clientViewSlice.reducer;
